import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  controlAreaClass: {
    display: "flex",
    minWidth: 180,
  },
  addButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    margin: 0,
    padding: 0,
    width: "100%",
  },
  filters: {
    margin: "0.8rem 0",
    display: "flex",
  },

  branchFilter: {
    width: "80%",
    paddingRight: "0.5rem",
  },
  dateFilter: {
    width: "20%",
    paddingRight: "0.5rem",
  },
  turnBlockFilter: {
    width: "20%",
  },
  exportButton: {
    transform: "rotate(180deg)",
  },
  quantity: {
    minWidth: "36px",    
    borderRadius: "2rem",
    width: "55px",
    '& input': {
      minWidth: '36px',
      textAlign: 'center',
      padding: '18.5px 0px',
    }
  },
  quotasInformation: {
    '&.Mui-disabled': {
      textTransform: "none",
      cursor: "auto",
      height: '67px',
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      margin: '0 16px 0 0',
      borderRadius: 0,
    }
  },
  quotasInformationNegative: {
    '&.Mui-disabled': {
      textTransform: "none",
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      cursor: "auto",
      height: '67px',
      color: theme.palette.red.main,
      margin: '0 16px 0 0',
      borderRadius: 0,
    }
  },
    rdt_TableCol_Sortable: {
      '& #column-capacity': {
        whiteSpace: "pre-wrap",
      }
    }
}));

export default useStyles;
